export interface Product {
  productId: string;
  displayPriceString: string;
}

export interface PromotionProduct {
  product: Product;
  discountProduct?: Product;
}

export interface ProductState {
  promotionItems: PromotionProduct[];
  items: Product[];
}

export const initialProductState: ProductState = {
  promotionItems: [],
  items: [],
};
